<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 10:48:08
 * @FilePath: /privacy-web/src/views/HomePage/ConsultService.vue
-->
<template>
  <div class="Consult-service-main" :class="{ 'Consult-service-main-mobile': isMobile }">
    <div class="title animate__animated" :class="animated">隐私保护咨询</div>
    <div class="remake animate__animated" :class="animated">
      如果您在使⽤贝壳产品或服务过程中，有任何隐私保护问题，欢迎与我们联系。
    </div>
    <el-button @click="questionnaire" class="animate__animated" :class="animated" round
      >反馈问题</el-button
    >
    <!-- <AuthenTication></AuthenTication> -->
  </div>
</template>
<script>
export default {
  name: "ConsultService",
  props: {
    animated: {
      type: String,
      default: "animate__zoomIn",
    },
  },
  methods: {
    questionnaire() {
      if (isMobile) {
        this.$router.push("/verification");
      } else {
        this.$router.push("/privacy-attestation");
        this.$store.commit("app/CHANGE_STATUS", true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.Consult-service-main {
  width: 100%;
  height: 100%;
  background: url("~assets/images/homePage/footer-img.png") center center no-repeat;
  background-size: cover !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.title {
  font-size: calc($multiple * 24px);
  font-family: PingFangTC-Medium, PingFangTC;
  font-weight: 500;
  color: #ffffff;
  line-height: calc($multiple * 33px);
  letter-spacing: 1px;
}
.remake {
  font-size: calc($multiple * 16px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: calc($multiple * 22px);
  letter-spacing: 1px;
  margin: calc($multiple * 31px) 0;
}
.el-button {
  width: calc($multiple * 171px);
  height: calc($multiple * 45px);
  line-height: calc($multiple * 45px);
  padding: 0 !important;
  text-align: center;
  border-radius: calc($multiple * 28px) !important;
  ::v-deep span {
    font-size: calc($multiple * 16px);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: calc($multiple * 22px);
    letter-spacing: 1px;
  }
}
.Consult-service-main-mobile {
  padding: 2.3rem 0 1.38rem;
  .title {
    font-size: 0.82rem;
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #ffffff;
    line-height: 1.13rem;
  }
  .remake {
    font-size: 0.72rem;
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #ffffff;
    line-height: 1.02rem;
    margin: 1.89rem 0 2.56rem;
    width: 16.44rem;
    text-align: center;
  }
  .el-button {
    width: 7.17rem;
    height: 1.64rem;
    line-height: 1.64rem;
    background: #0273f5;
    border-radius: 1.43rem;
    padding: 0 !important;
    text-align: center;
    ::v-deep span {
      font-size: 0.72rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 1.02rem;
      letter-spacing: 0.05rem;
    }
  }
}
</style>
